import { useQuery } from "@tanstack/react-query";
import { userService } from "../services/user";
import { useAuthUser } from "./useAuthUser";

export function useUserData() {
  const { user } = useAuthUser();

  const { data, ...rest } = useQuery({
    enabled: !!user?.uid,
    queryKey: ["getUserData_key", user?.uid],
    retry: 1,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    queryFn: () => userService.getUserData(user?.uid),
  });
  return { userData: data, ...rest };
}
